import { EnumTipologiaConsumoPasto } from '../StrumentoDiRegistrazioneArchivio';

export interface IGestioneSituazioneGiornalieraNidoInfanziaLattanti {
  assente: boolean;
  feci: number;
  frutta: EnumTipologiaConsumoPasto;
  menu: string;
  merenda: EnumTipologiaConsumoPasto;
  note: string;
  sonnoMattinoAlle: string;
  sonnoMattinoDalle: string;
  sonnoPomeriggioAlle: string;
  sonnoPomeriggioDalle: string;
}

export class GestioneSituazioneGiornalieraNidoInfanziaLattanti implements IGestioneSituazioneGiornalieraNidoInfanziaLattanti {
  assente: boolean;
  feci: number;
  frutta: EnumTipologiaConsumoPasto;
  menu: string;
  merenda: EnumTipologiaConsumoPasto;
  note: string;
  sonnoMattinoAlle: string;
  sonnoMattinoDalle: string;
  sonnoPomeriggioAlle: string;
  sonnoPomeriggioDalle: string;

  constructor(params?: Partial<IGestioneSituazioneGiornalieraNidoInfanziaLattanti>) {
    if (!params) {
      return;
    }

    Object.assign(this, params);
  }

  deconstructor(): IGestioneSituazioneGiornalieraNidoInfanziaLattanti {
    return Object.assign({ }, this);
  }
}
